/* unplugin-vue-components disabled */import script from "./mySendCodeMessageBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./mySendCodeMessageBtn.vue?vue&type=script&setup=true&lang=js"

import "./mySendCodeMessageBtn.vue?vue&type=style&index=0&id=4b33bdce&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/frontend_prod_master@2/project/wfzx-platform-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b33bdce"]])

export default __exports__